import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBarRef as MatSnackBarRef} from '@angular/material/legacy-snack-bar';

// Define type for action
export type Action = () => void | Promise<void>;

@Component({
  selector: 'mydocma-mm-extended-success-notification',
  templateUrl: './extended-notification.component.html',
  styleUrls: ['./extended-notification.component.scss']
})
export class ExtendedNotificationComponent implements OnInit {
  title: string;
  content: string;
  public data: {title: string, content: string, iconName: string, iconClass: string, buttonText: string, buttonAction: Action};

  constructor(@Inject(MAT_SNACK_BAR_DATA) public notification,
              @Optional() private snackBarRef: MatSnackBarRef<ExtendedNotificationComponent>) {

    this.data = notification.data[0];
    this.title = this.data.title;
    this.content = this.data.content;
  }

  ngOnInit(): void {
  }

  async callAction() {
    await this.data.buttonAction();
    this.snackBarRef.dismiss();
  }
  close() {
    this.snackBarRef.dismiss();
  }
}


